<template>
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.4453 14.4062H1.57813C1.5022 14.4062 1.42703 14.3913 1.35689 14.3622C1.28674 14.3332 1.22301 14.2906 1.16933 14.2369C1.11564 14.1832 1.07306 14.1195 1.04401 14.0494C1.01495 13.9792 1 13.904 1 13.8281V4.40625H15.375C15.5408 4.40625 15.6997 4.4721 15.8169 4.58931C15.9342 4.70652 16 4.86549 16 5.03125V13.8516C16 13.9987 15.9416 14.1398 15.8375 14.2438C15.7335 14.3478 15.5924 14.4062 15.4453 14.4062Z" stroke="#DADFE5" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.1875 1.80469L8.5 4.40625H1V2.21875C1 2.05299 1.06585 1.89402 1.18306 1.77681C1.30027 1.6596 1.45924 1.59375 1.625 1.59375H5.71875C5.80737 1.59367 5.895 1.61243 5.97581 1.6488C6.05663 1.68517 6.12879 1.7383 6.1875 1.80469Z" stroke="#DADFE5" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {
  name: "SmallFolderIcon"
}
</script>

<style scoped>

</style>
